import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { frame: String };

  start() {
    const frame = document.getElementById(this.frameValue);
    if (!frame) return;

    this.element.classList.add("is-loading");
    this.observer = new MutationObserver(() => {
      if (!frame.hasAttribute("busy")) this.stop();
    });
    this.observer.observe(frame, { attributeFilter: ["busy"] });
  }

  stop() {
    if (this.observer) this.observer.disconnect();
    this.element.classList.remove("is-loading");
  }

  disconnect() {
    this.stop();
  }
}
